const POS_RESEARCH_INFO = {
	researchTitle: "Reference Lookup",
	researchBadge: "Master DB",
	researchTagline: "Compare only — view, not sold",
	researchTooltip:
		"Browse similar medicines, brands, or salt names from the master database. For study and comparison only — no sales or inventory changes.",
	searchOtcLabel: "OTC",
	searchOtcTooltip:
		"Show OTC products in this reference list. Off = medicines only. In-stock items above are unchanged.",
	researchLoading: "Searching...",
	researchEmpty: "No results",
};

export { POS_RESEARCH_INFO };
